// React/Gatsby
import React, { useState } from "react"

// Other libs
import * as yup from "yup"
import { Box, Button, Typography, InputBase } from "@mui/material"

// Mailchimp
import addToMailchimp from "gatsby-plugin-mailchimp"

// Arrow icon
import arrow from "../../assets/arrow-cropped.svg"

function isValidEmail(email) {
  return yup.string().email().required().isValid(email)
}

export default function EmailOnlyForm(props) {
  const [email, setEmail] = useState("")
  const [emailIsValid, setEmailIsValid] = useState(true)
  const [message, setMessage] = useState("")

  const handleChange = (prop) => (event) => setEmail(event.target.value)

  const handleSubmitClick = async (e) => {
    const valid = await isValidEmail(email)
    console.log(valid)
    // Change this to actually submit the email instead of linking to a form
    if (valid) {
      e.preventDefault()
      try {
        const result = await addToMailchimp(email)
        if (result.result === "success") {
          setMessage("Thanks for subscribing!")
          console.log("Email sub succeeded")
        } else if (result.result === "error") {
          setMessage("Please try again.")
          console.log("Email sub failed")
        }
      } catch {
        setMessage("Please try disabling your ad-blocker.")
      }
    } else {
      setMessage("Please use a valid email address")
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        left: `-8px`, // Theme spacing doesn't work with left? otherwise use 1
      }}
    >
      <Typography sx={{ marginLeft: 1 }}>STAY UPDATED</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: 300,
          borderBottom: `1px solid black`,
          borderColor: "borders",
        }}
      >
        <InputBase
          id="email-input"
          placeholder="enter your email"
          onChange={handleChange("email")}
          value={email || ""}
          error={!emailIsValid}
          sx={{
            border: "none",
            marginLeft: 1,
            paddingTop: 1,
            paddingBottom: 1,
            "& ::placeholder": {
              opacity: 1,
            },
            "& :focus::placeholder": {
              opacity: 0.5,
            },
          }}
        />
        <Button
          id="submit-btn"
          onClick={handleSubmitClick}
          sx={{
            padding: 0,
            fontSize: 20,
            color: "black",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <img
            src={arrow}
            style={{ width: `22px`, paddingBottom: `13px` }}
            alt="arrow"
          />
        </Button>
      </Box>
      {message.length > 0 && (
        <Typography sx={{ marginLeft: 1, marginTop: 1, width: 250 }}>
          {message}
        </Typography>
      )}
    </Box>
  )
}
